import "./App.css"
import BestQuotes from "./components/BestQuotes";
import Details from "./components/Details";
import FloorPlan from "./components/FloorPlan";
import Footer from "./components/Footer";
import Form from "./components/Form";
import Header from "./components/Header";
import Hero from "./components/Hero";
import StripSection from "./components/StripSection";
import Pricing from "./components/Pricing";
import NewForm from "./components/NewForm";
import AboutDeveloper from "./components/AboutDeveloper";
import Slider from "./components/Slider";
function App() {
const project = "Hiranandani Chembur";

  const galleryImages = [
    {
      src: "images/lntevaraheights-Gallery-Yoga.webp",
      alt: "gallery1",
      title: "gallery1",
    },
    {
      src: "images/lntevaraheights-Gallery-Lawn.webp",
      alt: "gallery2",
      title: "gallery2",
    },
    {
      src: "images/lntevaraheights-Gallery-Creche.webp",
      alt: "gallery3",
      title: "gallery3",
    },
    {
      src: "images/lntevaraheights-Gallery-Bedroom.webp",
      alt: "gallery4",
      title: "gallery4",
    },
    {
      src: "images/lntevaraheights-Gallery-Banquet.webp",
      alt: "gallery5",
      title: "gallery5",
    }
    // Add more amenities as needed
  ];
  const amenityImages = [
    {
      src: "images/lntevaraheightsindoorgameroom.webp",
      alt: "Indoor game room",
      title: "Indoor game room",
    },
    {
      src: "images/lntevaraheightskidsplayarea.webp",
      alt: "Kids play area",
      title: "Kids play area",
    },
    {
      src: "images/lntevaraheights247security.webp",
      alt: "24x7 Security",
      title: "24x7 Security",
    },
    {
      src: "images/lntevaraheights-Gallery-Gym.webp",
      alt: "Gym",
      title: "Gym",
    },
    {
      src: "images/lntevaraheights-Gallery-Swimming-pool-view.webp",
      alt: "Swimming Pool",
      title: "Swimming Pool",
    }
    // Add more amenities as needed
  ];
  return (
    <>
      <div className="App">
        <Header />
        <Hero />
        <NewForm />
        <StripSection />
        <Details project={project} />
        <Pricing project={project} />
        <FloorPlan project={project} />
        <Slider project={project} title="Amenities" images={amenityImages} />
        <Slider project={project} title="Gallery" images={galleryImages} />
        <BestQuotes />
        <AboutDeveloper/>
        <Footer />
        <Form />
      </div>
    </>
  );
}


export default App;
